export default __webpack_public_path__ + "static/media/back.d5e5b7d7.svg";